import React from 'react';
import { Check, Lock } from 'lucide-react';
interface PricingGridProps {
  selectedPack: number;
  setSelectedPack: (pack: number) => void;
  packLinks: string[];
}
export function PricingGrid({
  selectedPack,
  setSelectedPack,
  packLinks
}: PricingGridProps) {
  return <div data-id="element-2">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-5" data-id="element-3">
        {/* Pack 0: Pack Completo */}
        <button onClick={() => setSelectedPack(0)} className={`relative text-left rounded-xl p-2 md:p-3 transition-all duration-200 cursor-pointer ${selectedPack === 0 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_15px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-4">
          <div className={`absolute top-2 right-2 w-3 h-3 md:w-4 md:h-4 rounded-full border-2 flex items-center justify-center ${selectedPack === 0 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-5">
            {selectedPack === 0 && <Check className="w-2 h-2 md:w-2.5 md:h-2.5 text-white" data-id="element-6" />}
          </div>
          <div className="text-lg mb-0.5" data-id="element-7">🏢</div>
          <h3 className="text-xs md:text-sm font-black text-white mb-0.5 pr-4 leading-tight" data-id="element-8">
            Pack Completo{' '}
            <span className="text-[#22c55e]" data-id="element-9">Teoría de las Organizaciones</span>
          </h3>
          <ul className="space-y-0.5 mb-1.5" data-id="element-10">
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-11">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-12" />
              6 tomos completos
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-13">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-14" />
              4 bonus incluidos
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-15">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-16" />
              Acceso inmediato
            </li>
          </ul>
          <div className="flex items-baseline gap-1" data-id="element-17">
            <span className="text-lg md:text-xl font-black text-white" data-id="element-18">
              $19.990
            </span>
          </div>
          <span className="text-gray-600 text-[10px] line-through" data-id="element-19">
            $39.990
          </span>
        </button>

        {/* Pack 1: Pack Completo + Proyectos (NEW) */}
        <button onClick={() => setSelectedPack(1)} className={`relative text-left rounded-xl p-2 md:p-3 transition-all duration-200 cursor-pointer ${selectedPack === 1 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_15px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-20">
          <span className="absolute -top-2 left-1/2 -translate-x-1/2 bg-[#22c55e] text-white text-[8px] md:text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap shadow-md" data-id="element-21">
            ⭐ Más elegido
          </span>
          <div className={`absolute top-2 right-2 w-3 h-3 md:w-4 md:h-4 rounded-full border-2 flex items-center justify-center ${selectedPack === 1 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-22">
            {selectedPack === 1 && <Check className="w-2 h-2 md:w-2.5 md:h-2.5 text-white" data-id="element-23" />}
          </div>
          <div className="text-lg mb-0.5" data-id="element-24">🚀</div>
          <h3 className="text-xs md:text-sm font-black text-white mb-0.5 pr-4 leading-tight" data-id="element-25">
            Pack Completo{' '}
            <span className="text-[#22c55e]" data-id="element-26">
              Teoría de las Organizaciones + Sistema Avanzado de Proyectos
              Organizacionales
            </span>
          </h3>
          <ul className="space-y-0.5 mb-1.5" data-id="element-27">
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-28">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-29" />
              Kit completo de Organizaciones
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-30">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-31" />
              Sistema Avanzado de Proyectos
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-32">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-33" />
              Todos los bonus incluidos
            </li>
          </ul>
          <div className="flex items-baseline gap-1" data-id="element-34">
            <span className="text-lg md:text-xl font-black text-white" data-id="element-35">
              $27.990
            </span>
          </div>
          <span className="text-gray-600 text-[10px] line-through" data-id="element-36">
            $54.990
          </span>
        </button>

        {/* Pack 2: Combo Orga + Eco */}
        <button onClick={() => setSelectedPack(2)} className={`relative text-left rounded-xl p-2 md:p-3 transition-all duration-200 cursor-pointer ${selectedPack === 2 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_15px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-37">
          <div className={`absolute top-2 right-2 w-3 h-3 md:w-4 md:h-4 rounded-full border-2 flex items-center justify-center ${selectedPack === 2 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-38">
            {selectedPack === 2 && <Check className="w-2 h-2 md:w-2.5 md:h-2.5 text-white" data-id="element-39" />}
          </div>
          <div className="text-lg mb-0.5" data-id="element-40">📚</div>
          <h3 className="text-xs md:text-sm font-black text-white mb-0.5 pr-4 leading-tight" data-id="element-41">
            Combo{' '}
            <span className="text-[#22c55e]" data-id="element-42">
              Teoría de las Organizaciones + Economía Lista
            </span>
          </h3>
          <ul className="space-y-0.5 mb-1.5" data-id="element-43">
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-44">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-45" />
              Kit completo de Organizaciones
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-46">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-47" />
              Kit completo de Economía
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-48">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-49" />
              Todos los bonus de ambos kits
            </li>
          </ul>
          <div className="flex items-baseline gap-1" data-id="element-50">
            <span className="text-lg md:text-xl font-black text-white" data-id="element-51">
              $37.990
            </span>
          </div>
          <span className="text-gray-600 text-[10px] line-through" data-id="element-52">
            $69.990
          </span>
        </button>

        {/* Pack 3: Combo Orga + Conta */}
        <button onClick={() => setSelectedPack(3)} className={`relative text-left rounded-xl p-2 md:p-3 transition-all duration-200 cursor-pointer ${selectedPack === 3 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_15px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-53">
          <div className={`absolute top-2 right-2 w-3 h-3 md:w-4 md:h-4 rounded-full border-2 flex items-center justify-center ${selectedPack === 3 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-54">
            {selectedPack === 3 && <Check className="w-2 h-2 md:w-2.5 md:h-2.5 text-white" data-id="element-55" />}
          </div>
          <div className="text-lg mb-0.5" data-id="element-56">🧮</div>
          <h3 className="text-xs md:text-sm font-black text-white mb-0.5 pr-4 leading-tight" data-id="element-57">
            Combo{' '}
            <span className="text-[#22c55e]" data-id="element-58">
              Teoría de las Organizaciones + Contabilidad Lista
            </span>
          </h3>
          <ul className="space-y-0.5 mb-1.5" data-id="element-59">
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-60">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-61" />
              Kit completo de Organizaciones
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-62">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-63" />
              Kit completo de Contabilidad
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-64">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-65" />
              Todos los bonus de ambos kits
            </li>
          </ul>
          <div className="flex items-baseline gap-1" data-id="element-66">
            <span className="text-lg md:text-xl font-black text-white" data-id="element-67">
              $37.990
            </span>
          </div>
          <span className="text-gray-600 text-[10px] line-through" data-id="element-68">
            $69.990
          </span>
        </button>

        {/* Pack 4: Combo Orga + Edu Fin */}
        <button onClick={() => setSelectedPack(4)} className={`relative text-left rounded-xl p-2 md:p-3 transition-all duration-200 cursor-pointer ${selectedPack === 4 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_15px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-69">
          <div className={`absolute top-2 right-2 w-3 h-3 md:w-4 md:h-4 rounded-full border-2 flex items-center justify-center ${selectedPack === 4 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-70">
            {selectedPack === 4 && <Check className="w-2 h-2 md:w-2.5 md:h-2.5 text-white" data-id="element-71" />}
          </div>
          <div className="text-lg mb-0.5" data-id="element-72">💰</div>
          <h3 className="text-xs md:text-sm font-black text-white mb-0.5 pr-4 leading-tight" data-id="element-73">
            Combo{' '}
            <span className="text-[#22c55e]" data-id="element-74">
              Teoría de las Organizaciones + Educación Financiera
            </span>
          </h3>
          <ul className="space-y-0.5 mb-1.5" data-id="element-75">
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-76">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-77" />
              Kit completo de Organizaciones
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-78">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-79" />
              Kit completo de Educación Financiera
            </li>
            <li className="flex items-start gap-1 text-gray-400 text-[9px] md:text-[11px] leading-tight" data-id="element-80">
              <Check className="w-2.5 h-2.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-81" />
              Todos los bonus de ambos kits
            </li>
          </ul>
          <div className="flex items-baseline gap-1" data-id="element-82">
            <span className="text-lg md:text-xl font-black text-white" data-id="element-83">
              $37.990
            </span>
          </div>
          <span className="text-gray-600 text-[10px] line-through" data-id="element-84">
            $69.990
          </span>
        </button>
      </div>

      {/* CTA Button */}
      <div className="text-center mb-3 md:mb-4" data-id="element-85">
        <a href={packLinks[selectedPack]} className="inline-flex items-center justify-center gap-1.5 w-full md:w-auto bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-base md:text-lg py-2.5 px-6 md:py-3 md:px-10 rounded-xl shadow-[0_0_20px_rgba(34,197,94,0.3)] transform hover:scale-[1.02] transition-all duration-200" data-id="element-86">
          Sí, quiero mi pack →
        </a>
        <p className="text-gray-500 text-[10px] md:text-xs font-medium mt-2 flex items-center justify-center gap-1" data-id="element-87">
          <Lock className="w-3 h-3" data-id="element-88" /> PAGO SEGURO CON MERCADO PAGO
        </p>
      </div>
    </div>;
}